<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Programaciones</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link to="/Flota">Planta Externa</router-link>
                  </li>
                  <li class="breadcrumb-item active">Programaciones</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <fieldset class="well card">
              <legend class="well-legend text-bold text-light">
                {{ accion }} Cargue Programación
                <span v-if="form.id"> - {{ form.id }}</span>
              </legend>

              <div class="row mt-0 mb-3">
                <div class="col-md-4"></div>
                <div v-if="form.id" class="col-md-4">
                  <div class="small-box shadow m-2">
                    <div class="inner">
                      <div class="col-md-9">
                        <label for="estado">Estado</label>
                        <select
                          :disabled="bloquear"
                          :class="[
                            $v.form.estado.$invalid ? 'is-invalid' : 'is-valid',
                            'form-control form-control-sm',
                          ]"
                          v-model="form.estado"
                          @change="validarEstado()"
                        >
                          <option value="">Seleccione...</option>
                          <option
                            v-for="estado in listasForms.estados"
                            :key="estado.numeracion"
                            :value="estado.numeracion"
                          >
                            {{ estado.descripcion }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="icon icon-sm">
                      <i class="ion ion-more text-navy"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-md-6 mb-3">
                  <div class="small-box shadow m-2" style="min-height: 100px">
                    <div class="inner">
                      <div class="col-md-9">
                        <h6><b>Nombre</b></h6>
                        <input
                          :disabled="bloquear"
                          type="text"
                          class="form-control form-control-sm"
                          v-model="form.nombre"
                          :class="[
                            $v.form.nombre.$invalid ? 'is-invalid' : 'is-valid',
                          ]"
                        />
                      </div>
                    </div>
                    <div class="icon icon-sm">
                      <i class="ion ion-more text-navy"></i>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <div class="small-box shadow m-2" style="min-height: 100px">
                    <div class="inner">
                      <div class="col-md-9">
                        <h6><b>Fecha Programación</b></h6>
                        <div class="row">
                          <input
                            type="date"
                            :disabled="bloquear"
                            v-model="form.fecha"
                            style="font-size: 13px"
                            class="form-control form-control-sm col-md-11 mr-1"
                            :class="[
                              $v.form.fecha.$invalid
                                ? 'is-invalid'
                                : 'is-valid',
                            ]"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="icon icon-sm">
                      <i class="ion ion-calendar text-navy"></i>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <div class="small-box shadow m-2" style="min-height: 100px">
                    <div class="inner">
                      <div class="col-md-9">
                        <h6><b>Bloque</b></h6>
                        <v-select
                          :disabled="bloquear"
                          :class="[
                            'form-control form-control-sm p-0',
                            $v.form.bloque_id.$invalid
                              ? 'is-invalid'
                              : 'is-valid',
                          ]"
                          v-model="form.bloque_id"
                          :options="listasForms.bloques"
                          label="nombre"
                          :reduce="(item) => item.id"
                        />
                      </div>
                    </div>
                    <div class="icon icon-sm">
                      <i class="ion ion-more text-navy"></i>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <div class="small-box shadow m-2" style="min-height: 100px">
                    <div class="inner">
                      <div class="col-md-9">
                        <h6><b>Observacion</b></h6>
                        <textarea
                          :disabled="bloquear"
                          class="form-control form-control-sm"
                          v-model="form.observaciones"
                          :class="[
                            $v.form.observaciones.$invalid
                              ? 'is-invalid'
                              : 'is-valid',
                          ]"
                          rows="2"
                        ></textarea>
                      </div>
                    </div>
                    <div class="icon icon-sm">
                      <i class="ion ion-more text-navy"></i>
                    </div>
                  </div>
                </div>
                <div
                  :class="plantilla_cargue == null ? 'col-md-2' : 'col-md-1'"
                ></div>
                <div class="col-md-6 mb-3" v-if="accion == 'Editar'">
                  <div class="small-box shadow m-2" style="min-height: 100px">
                    <div class="inner">
                      <h6><b>Importar Plantilla</b></h6>
                      <div
                        class="col-md-12 mt-2"
                        :class="
                          plantilla_cargue == null
                            ? 'alert-default-warning border border-warning'
                            : 'alert-default-success border border-success'
                        "
                      >
                        <input
                          type="file"
                          id="file"
                          ref="file"
                          @change="elegirDirectorio()"
                          accept=".xlsx, .CSV"
                          class="form-control btn btn-secundary"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 mt-4" v-if="accion == 'Editar'">
                  <div class="btn-group">
                    <button
                      type="button"
                      class="btn bg-olive mr-1 shadow"
                      title="Plantilla"
                      @click="descargarPlantilla()"
                    >
                      <i class="fas fa-file-download"></i> Plantilla
                    </button>
                    <button
                      type="button"
                      class="btn bg-primary mr-1 shadow-sm"
                      title="Subir Plantilla"
                      @click="importarCargue()"
                      v-if="
                        plantilla_cargue &&
                          !$v.form.$invalid &&
                          $store.getters.can(
                            'plantaEx.progrmacion.createDetalles',
                          )
                      "
                    >
                      <i class="fas fa-file-upload"></i> Subir Plantilla
                    </button>
                    <button
                      type="button"
                      class="btn bg-danger shadow-sm"
                      @click="limpiarPlantilla()"
                      title="Limpiar Plantilla"
                      v-if="plantilla_cargue"
                    >
                      <i class="fas fa-trash-alt"></i> Limpiar
                    </button>
                    <button
                      type="button"
                      class="btn bg-danger shadow-sm"
                      @click="enviarCorreo()"
                      v-if="
                        $store.getters.can('plantaEx.progrmacion.enviarCorreo')
                      "
                    >
                      <i class="fas fa-envelope"></i> Enviar Correo
                    </button>
                  </div>
                </div>
              </div>

              <div class="row justify-content-center">
                <button
                  type="button"
                  class="btn bg-gradient-primary col-md-1 shadow mr-1"
                  title="Plantilla"
                  v-if="
                    !$v.form.$invalid &&
                      !bloquear &&
                      $store.getters.can('plantaEx.progrmacion.create')
                  "
                  @click="validarEstado(true)"
                >
                  <i class="fas fa-paper-plane"></i>
                  <div>Guardar</div>
                </button>
                <button
                  class="btn bg-gradient-secondary col-md-1 shadow"
                  @click="back()"
                >
                  <i class="fas fa-reply"></i>
                  <div>Volver</div>
                </button>
              </div>
            </fieldset>
            <!-- detalles -->

            <fieldset
              class="well card"
              v-if="
                accion == 'Editar' &&
                  $store.getters.can('plantaEx.progrmacion.showDetalles')
              "
            >
              <legend class="well-legend text-bold text-light">
                Filtros - <span>Detalles</span>
              </legend>
              <div class="col-md-12 p-0">
                <div class="btn-group float-right border-0">
                  <div class="card-tools">
                    <button
                      type="button"
                      class="btn bg-gradient-navy mr-2 shadow"
                      title="Actualizar"
                      @click="getIndex()"
                    >
                      <i class="fas fa-sync-alt fa-spin"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-danger mr-2 shadow"
                      title="Limpiar Filtros"
                      @click="limpiarFiltros()"
                    >
                      <i class="fas fa-broom"></i>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Filtros -->
              <div class="row justify-content-center">
                <!-- empresa -->
                <div class="form-group col-md-3">
                  <label>Despachado A</label>
                  <v-select
                    placeholder="Empresa"
                    label="razon_social"
                    v-model="filtros.empresa_id"
                    class="form-control form-control-sm shadow-sm p-0"
                    :options="listasForms.empresas"
                    :reduce="(item) => item.id"
                    @input="getIndex()"
                  >
                  </v-select>
                </div>
                <!-- tipo vehiculo -->
                <div class="form-group col-md-3">
                  <label>Tipo Vehiculo</label>
                  <v-select
                    placeholder="Tipo Vehiculo"
                    label="nombre"
                    v-model="filtros.tipo_vehiculo_id"
                    class="form-control form-control-sm shadow-sm p-0"
                    :options="listasForms.tipoVehiculo"
                    :reduce="(item) => item.id"
                    @input="getIndex()"
                  >
                  </v-select>
                </div>
                <!-- Origen -->
                <div class="form-group col-md-3">
                  <label>Origen</label>
                  <v-select
                    placeholder="Origen"
                    label="nombre"
                    v-model="filtros.origen"
                    class="form-control form-control-sm shadow-sm p-0"
                    :options="listasForms.sitios"
                    :reduce="(item) => item.id"
                    @input="getIndex()"
                  >
                  </v-select>
                </div>
                <!-- Destino -->
                <div class="form-group col-md-3">
                  <label>Destino</label>
                  <v-select
                    placeholder="Destino"
                    label="nombre"
                    v-model="filtros.destino"
                    class="form-control form-control-sm shadow-sm p-0"
                    :options="listasForms.sitios"
                    :reduce="(item) => item.id"
                    @input="getIndex()"
                  >
                  </v-select>
                </div>
                <!-- Cecos y afes -->
                <div class="form-group col-md-3">
                  <label>Imputacion</label>
                  <v-select
                    placeholder="Cecos y Afes"
                    label="codigo_contable"
                    v-model="filtros.imputacion"
                    class="form-control form-control-sm shadow-sm p-0"
                    :options="listasForms.cecos"
                    :reduce="(item) => item.id"
                    @input="getIndex()"
                  >
                  </v-select>
                </div>
                <!-- Areas -->
                <div class="form-group col-md-3">
                  <label>Area</label>
                  <v-select
                    placeholder="Areas"
                    label="descripcion"
                    v-model="filtros.area"
                    class="form-control form-control-sm shadow-sm p-0"
                    :options="listasForms.areas"
                    :reduce="(item) => item.numeracion"
                    @input="getIndex()"
                  >
                  </v-select>
                </div>
                <!-- Numero contacto -->
                <div class="form-group col-md-3">
                  <label>Numero Contacto</label>
                  <input
                    type="text"
                    placeholder="Numero Contacto"
                    v-model="filtros.numero_contacto"
                    class="form-control form-control-sm shadow-sm"
                    @change="getIndex()"
                  />
                </div>
                <!-- Tipo producto -->
                <div class="form-group col-md-3">
                  <label>Tipo Producto</label>
                  <v-select
                    placeholder="Tipo producto"
                    label="nombre"
                    v-model="filtros.tipo_producto"
                    class="form-control form-control-sm shadow-sm p-0"
                    :options="listasForms.productos"
                    :reduce="(item) => item.id"
                    @input="getIndex()"
                  >
                  </v-select>
                </div>
                <!-- Fecha -->
                <div class="form-group col-md-3">
                  <label>Fecha Cita</label>
                  <input
                    type="date"
                    placeholder="Fecha cita"
                    v-model="filtros.fecha_cita"
                    class="form-control form-control-sm shadow-sm"
                    @change="getIndex()"
                  />
                </div>
                <!-- Observacion -->
                <div class="form-group col-md-3">
                  <label>Observacion</label>
                  <input
                    type="text"
                    placeholder="Observacion"
                    v-model="filtros.observacion"
                    class="form-control form-control-sm shadow-sm"
                    @change="getIndex()"
                  />
                </div>
                <!-- Estado -->
                <div class="form-group col-md-3">
                  <label>Estado</label>
                  <select
                    v-model="filtros.estado"
                    @change="getIndex()"
                    class="form-control form-control-sm"
                  >
                    <option value="">Todos..</option>
                    <option
                      v-for="estado in listasForms.det_estados"
                      v-bind:key="estado.id"
                      v-bind:value="estado.numeracion"
                    >
                      {{ estado.descripcion }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- Detalle Planta Externa -->
              <div class="card mt-2">
                <div class="card mb-0">
                  <div class="card-header bg-gradient-navy pt-2 pb-2">
                    <h3 class="card-title">
                      <i class="fas fa-clipboard-check bg-success"></i>
                      Detalles Programaciones
                    </h3>
                    <div class="card-tools">
                      <button
                        type="button"
                        class="btn btn-tool"
                        data-card-widget="collapse"
                        data-toggle="tooltip"
                        title="Collapse"
                      >
                        <i class="fas fa-minus"></i>
                      </button>
                    </div>
                  </div>
                  <div class="card-body pb-0">
                    <div class="table-scroll-x">
                      <table
                        class="table table-bordered table-striped table-hover table-sm shadow tabla-ancha"
                      >
                        <thead class="bg-gradient-secondary">
                          <tr>
                            <th class="text-center p-2" style="min-width: 20em">
                              Despachado A
                            </th>
                            <th class="text-center p-2" style="min-width: 20em">
                              Tipo Vehiculo
                            </th>
                            <th class="text-center p-2" style="min-width: 20em">
                              Campo
                            </th>
                            <th class="text-center p-2" style="min-width: 20em">
                              Destino
                            </th>
                            <th class="text-center p-2" style="min-width: 20em">
                              Imputacion
                            </th>
                            <th class="text-center p-2" style="min-width: 20em">
                              Area
                            </th>
                            <th class="text-center p-2" style="min-width: 10em">
                              Equipo
                            </th>
                            <th class="text-center p-2" style="min-width: 10em">
                              Origen
                            </th>
                            <th class="text-center p-2" style="min-width: 10em">
                              Numero Contacto
                            </th>
                            <th class="text-center p-2">Tipo Producto</th>
                            <th class="text-center p-2">Fecha Cita</th>
                            <th class="text-center p-2" style="min-width: 20em">
                              Observacion
                            </th>
                            <th class="text-center p-2">Estado</th>
                            <th class="text-center p-2" v-if="form.estado == 1">
                              Acciones
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <!-- Detalles programaciones -->
                          <tr
                            v-for="(detalle,
                            index) in det_programaciones?.data || []"
                            :key="index"
                          >
                            <td class="text-center">
                              <span
                                v-if="
                                  !editedItem || editedItem.id !== detalle.id
                                "
                              >
                                {{
                                  detalle.empresa
                                    ? detalle.empresa.razon_social
                                    : ""
                                }}
                              </span>
                              <div class="text-center-0">
                                <v-select
                                  v-if="
                                    editedItem && editedItem.id === detalle.id
                                  "
                                  v-model="editedItem.empresa_id"
                                  :options="listasForms.empresas"
                                  label="razon_social"
                                  :reduce="(item) => item.id"
                                  :class="[
                                    editedItem.empresa_id
                                      ? 'border border-success'
                                      : 'border border-danger',
                                  ]"
                                />
                              </div>
                            </td>
                            <td class="text-center">
                              <span
                                v-if="
                                  !editedItem || editedItem.id !== detalle.id
                                "
                              >
                                {{
                                  detalle.tipo_vehiculo
                                    ? detalle.tipo_vehiculo.nombre
                                    : ""
                                }}
                              </span>
                              <div class="text-center-0">
                                <v-select
                                  v-if="
                                    editedItem && editedItem.id === detalle.id
                                  "
                                  v-model="editedItem.tipo_vehiculo_id"
                                  :options="listasForms.tipoVehiculo"
                                  label="nombre"
                                  :reduce="(item) => item.id"
                                  :class="[
                                    editedItem.tipo_vehiculo_id
                                      ? 'border border-success'
                                      : 'border border-danger',
                                  ]"
                                />
                              </div>
                            </td>
                            <td class="text-center">
                              <span
                                v-if="
                                  !editedItem || editedItem.id !== detalle.id
                                "
                              >
                                {{
                                  detalle.origen ? detalle.origen.nombre : ""
                                }}
                              </span>
                              <div class="text-center-0">
                                <v-select
                                  v-if="
                                    editedItem && editedItem.id === detalle.id
                                  "
                                  v-model="editedItem.origen_id"
                                  :options="listasForms.sitios"
                                  label="nombre"
                                  :reduce="(item) => item.id"
                                  :class="[
                                    editedItem.origen_id
                                      ? 'border border-success'
                                      : 'border border-danger',
                                  ]"
                                />
                              </div>
                            </td>
                            <td class="text-center">
                              <span
                                v-if="
                                  !editedItem || editedItem.id !== detalle.id
                                "
                              >
                                {{ detalle.destino?.nombre }}
                              </span>
                              <div class="text-center-0">
                                <v-select
                                  v-if="
                                    editedItem && editedItem.id === detalle.id
                                  "
                                  v-model="editedItem.destino_id"
                                  :options="listasForms.sitios"
                                  label="nombre"
                                  :reduce="(item) => item.id"
                                  :class="[
                                    editedItem.destino_id
                                      ? 'border border-success'
                                      : 'border border-danger',
                                  ]"
                                />
                              </div>
                            </td>
                            <td class="text-center">
                              <span
                                v-if="
                                  !editedItem || editedItem.id !== detalle.id
                                "
                              >
                                {{ detalle.imputacion?.codigo_contable }}
                              </span>
                              <v-select
                                :class="[
                                  editedItem.ceco_afe_id
                                    ? 'border border-success'
                                    : 'border border-danger',
                                ]"
                                v-if="
                                  editedItem && editedItem.id === detalle.id
                                "
                                v-model="editedItem.ceco_afe_id"
                                :options="listasForms.cecos"
                                label="codigo_contable"
                                :reduce="(item) => item.id"
                              />
                            </td>
                            <td class="text-center">
                              <span
                                v-if="
                                  !editedItem || editedItem.id !== detalle.id
                                "
                              >
                                {{ detalle.area?.descripcion }}
                              </span>

                              <v-select
                                v-if="
                                  editedItem && editedItem.id === detalle.id
                                "
                                v-model="editedItem.area"
                                label="descripcion"
                                :options="listasForms.areas"
                                :reduce="(item) => item.numeracion"
                                :class="[
                                  editedItem.area
                                    ? 'border border-success'
                                    : 'border border-danger',
                                ]"
                              />
                            </td>
                            <td class="text-center">
                              <span
                                v-if="
                                  !editedItem || editedItem.id !== detalle.id
                                "
                              >
                                {{
                                  detalle.nombre_equipo
                                    ? detalle.nombre_equipo
                                    : ""
                                }}
                              </span>
                              <div class="text-center-0">
                                <input
                                  type="text"
                                  v-if="
                                    editedItem && editedItem.id === detalle.id
                                  "
                                  v-model="editedItem.nombre_equipo"
                                  class="form-control form-control-sm shadow-sm"
                                  :class="[
                                    editedItem.nombre_equipo
                                      ? 'border border-success'
                                      : 'border border-danger',
                                  ]"
                                />
                              </div>
                            </td>
                            <td class="text-center">
                              <span
                                v-if="
                                  !editedItem || editedItem.id !== detalle.id
                                "
                              >
                                {{
                                  detalle.nombre_origen
                                    ? detalle.nombre_origen
                                    : ""
                                }}
                              </span>
                              <div class="text-center-0">
                                <input
                                  type="text"
                                  v-if="
                                    editedItem && editedItem.id === detalle.id
                                  "
                                  v-model="editedItem.nombre_origen"
                                  class="form-control form-control-sm shadow-sm"
                                  :class="[
                                    editedItem.nombre_origen
                                      ? 'border border-success'
                                      : 'border border-danger',
                                  ]"
                                />
                              </div>
                            </td>
                            <td class="text-center">
                              <span
                                v-if="
                                  !editedItem || editedItem.id !== detalle.id
                                "
                              >
                                {{
                                  detalle.numero_contacto
                                    ? detalle.numero_contacto
                                    : ""
                                }}
                              </span>
                              <div class="text-center-0">
                                <input
                                  type="text"
                                  v-if="
                                    editedItem && editedItem.id === detalle.id
                                  "
                                  v-model="editedItem.numero_contacto"
                                  class="form-control form-control-sm shadow-sm"
                                  :class="[
                                    editedItem.numero_contacto
                                      ? 'border border-success'
                                      : 'border border-danger',
                                  ]"
                                />
                              </div>
                            </td>
                            <td class="text-center">
                              <span
                                v-if="
                                  !editedItem || editedItem.id !== detalle.id
                                "
                              >
                                {{ detalle.tipo_producto?.nombre }}
                              </span>

                              <v-select
                                v-if="
                                  editedItem && editedItem.id === detalle.id
                                "
                                v-model="editedItem.tipo_producto"
                                label="nombre"
                                :options="listasForms.productos"
                                :reduce="(item) => item.id"
                                :class="[
                                  editedItem.tipo_producto
                                    ? 'border border-success'
                                    : 'border border-danger',
                                ]"
                              />
                            </td>
                            <td class="text-center">
                              <span
                                v-if="
                                  !editedItem || editedItem.id !== detalle.id
                                "
                              >
                                {{
                                  detalle.fecha_cita ? detalle.fecha_cita : ""
                                }}
                              </span>
                              <div class="text-center-0">
                                <input
                                  type="datetime-local"
                                  v-if="
                                    editedItem && editedItem.id === detalle.id
                                  "
                                  v-model="editedItem.fecha_cita"
                                  class="form-control form-control-sm shadow-sm"
                                  :class="[
                                    editedItem.fecha_cita
                                      ? 'border border-success'
                                      : 'border border-danger',
                                  ]"
                                />
                              </div>
                            </td>
                            <td class="text-center">
                              <span
                                v-if="
                                  !editedItem || editedItem.id !== detalle.id
                                "
                              >
                                {{
                                  detalle.observacion ? detalle.observacion : ""
                                }}
                              </span>
                              <div class="text-center-0">
                                <input
                                  type="text"
                                  v-if="
                                    editedItem && editedItem.id === detalle.id
                                  "
                                  v-model="editedItem.observacion"
                                  class="form-control form-control-sm shadow-sm"
                                  :class="[
                                    editedItem.observacion
                                      ? 'border border-success'
                                      : 'border border-danger',
                                  ]"
                                />
                              </div>
                            </td>
                            <td class="text-center">
                              <span
                                class="badge shadow"
                                :class="
                                  detalle.estado == 1
                                    ? 'badge-warning'
                                    : 'badge-success'
                                "
                              >
                                {{ detalle.nEstado }}
                              </span>
                            </td>
                            <td class="text-center" v-if="form.estado == 1">
                              <!-- Modo vista -->
                              <button
                                v-if="
                                  (!editedItem ||
                                    editedItem.id !== detalle.id) &&
                                    detalle.estado === 2 &&
                                    $store.getters.can(
                                      'plantaEx.progrmacion.editDetalles',
                                    )
                                "
                                class="btn btn-sm bg-gradient-navy"
                                @click="editDetalle(detalle)"
                              >
                                <i class="fas fa-edit"></i>
                              </button>

                              <button
                                type="button"
                                class="btn btn-sm btn-danger"
                                v-if="
                                  (!editedItem ||
                                    editedItem.id !== detalle.id) &&
                                    form.estado == 1 &&
                                    $store.getters.can(
                                      'plantaEx.progrmacion.deleteDetalles',
                                    )
                                "
                                @click="destroy(detalle.id)"
                              >
                                <i class="fas fa-trash-alt"></i>
                              </button>

                              <!-- Modo edición -->
                              <template
                                v-if="
                                  editedItem && editedItem.id === detalle.id
                                "
                              >
                                <button
                                  v-if="
                                    editedItem && editedItem.id === detalle.id
                                  "
                                  class="btn btn-sm btn-success mr-1"
                                  @click="saveDetalle()"
                                >
                                  <i class="fas fa-save"></i>
                                </button>

                                <button
                                  class="btn btn-sm btn-danger"
                                  @click="cancelEdit()"
                                >
                                  <i class="fas fa-times"></i>
                                </button>
                              </template>
                            </td>
                          </tr>
                          <!-- Fin detalles programaciones -->
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="card-footer shadow">
                    <!-- Paginación detalles programaciones -->
                    <div class="float-left" v-if="det_programaciones.total">
                      Mostrando del <b>{{ det_programaciones.from }}</b> al
                      <b>{{ det_programaciones.to }}</b> de un total:
                      <b>{{ det_programaciones.total }}</b> Registros
                    </div>
                    <div class="float-left" v-else>
                      <span class="badge badge-danger">
                        No hay registros para mostrar
                      </span>
                    </div>
                    <pagination
                      :data="det_programaciones"
                      @pagination-change-page="getIndex"
                      :limit="5"
                      class="float-right m-0"
                    ></pagination>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import loading from "@/components/Loading.vue";
import { required } from "vuelidate/lib/validators";
import pagination from "laravel-vue-pagination";
import vSelect from "vue-select";

export default {
  name: "PlantProgramacionForm",
  components: {
    vSelect,
    pagination,
    loading,
  },
  data() {
    return {
      form: {
        id: null,
        fecha: null,
        nombre: null,
        empresa_id: null,
        estado: null,
      },
      accion: null,
      metodo: null,
      plantilla_cargue: null,
      editedItem: null,
      cargando: false,
      bloquear: false,
      filtros: {
        programacion_id: null,
        empresa_id: null,
        tipo_vehiculo_id: null,
        destino: null,
        imputacion: null,
        area: null,
        origen: null,
        tipo_producto: null,
        fecha_cita: null,
        observacion: null,
        estado: null,
        numero_contacto: null,
      },
      det_programaciones: {},
      listasForms: {
        empresas: [],
        estados: [],
        det_estados: [],
        campos: [],
        tipoVehiculo: [],
        sitios: [],
        bloques: [],
        cecos: [],
        areas: [],
        productos: [],
      },
    };
  },

  validations: {
    form: {
      estado: {
        required,
      },
      nombre: {
        required,
      },
      fecha: {
        required,
      },
      bloque_id: {
        required,
      },
      observaciones: {
        required,
      },
    },
  },

  methods: {
    destroy(id) {
      this.$swal({
        title: "Esta seguro de eliminar este detalle de programación?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        if (result.value) {
          this.cargando = true;
          axios
            .delete("/api/plant/programacionDetalles/" + id)
            .then((response) => {
              this.getIndex();

              this.$swal({
                icon: "success",
                title: response.data.msg,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 4000,
              });
            })
            .catch((error) => {
              this.$swal({
                icon: "error",
                title:
                  error.response?.data?.msg || "Ocurrió un error al eliminar",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 4000,
              });
            })
            .finally(() => {
              this.cargando = false;
            });
        }
      });
    },

    limpiarFiltros() {
      this.filtros = {};
      this.getIndex();
    },

    getSitios() {
      axios.get("/api/plant/sitios/lista").then((response) => {
        this.listasForms.sitios = response.data;
      });
    },

    getBloques() {
      axios.get("/api/plant/bloques/lista").then((response) => {
        this.listasForms.bloques = response.data;
      });
    },

    getCecosYAfes() {
      axios.get("/api/admin/cecosYafes/lista").then((response) => {
        this.listasForms.cecos = response.data;
      });
    },

    getTipoProducto() {
      axios.get("/api/admin/productos/lista").then((response) => {
        this.listasForms.productos = response.data;
      });
    },

    cancelEdit() {
      this.editedItem = null;
    },

    editDetalle(detalle) {
      this.editedItem = {
        id: detalle.id,
        plant_programacion_id: detalle.plant_programacion_id,
        empresa_id: detalle.empresa_id,
        tipo_vehiculo_id: detalle.tipo_vehiculo_id,
        destino_id: detalle.destino_id,
        bloque_id: detalle.bloque_id,
        ceco_afe_id: detalle.ceco_afe_id,
        area: detalle.area,
        numero_contacto: detalle.numero_contacto,
        nombre_equipo: detalle.nombre_equipo,
        nombre_origen: detalle.nombre_origen,
        tipo_producto: detalle.tipo_producto,
        fecha_cita: detalle.fecha_cita,
        observacion: detalle.observacion,
        estado: detalle.estado,
        original: { ...detalle },
      };
    },

    async saveDetalle() {
      try {
        await axios.put(
          `/api/plant/programacionDetalles/${this.editedItem.id}`,
          {
            empresa_id: this.editedItem.empresa_id,
            tipo_vehiculo_id: this.editedItem.tipo_vehiculo_id,
            destino_id: this.editedItem.destino_id,
            bloque_id: this.editedItem.bloque_id,
            ceco_afe_id: this.editedItem.ceco_afe_id,
            area: this.editedItem.area,
            nombre_equipo: this.editedItem.nombre_equipo,
            nombre_origen: this.editedItem.nombre_origen,
            tipo_producto_id: this.editedItem.tipo_producto,
            numero_contacto: this.editedItem.numero_contacto,
            fecha_cita: this.editedItem.fecha_cita,
            observacion: this.editedItem.observacion,
          },
        );

        this.$swal({
          icon: "success",
          title: "Detalle actualizado correctamente",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        this.editedItem = null;
        this.getIndex();
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Error al actualizar el detalle",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    },

    async getIndex(page = 1) {
      let me = this;
      me.cargando = true;
      me.accion = me.accion ? me.accion : me.$route.params.accion;
      if (me.accion == "Crear") {
        me.metodo = "post";
        me.form.estado = 1;
        me.cargando = false;
      }
      if (me.accion == "Editar") {
        me.form = me.form.id ? me.form : me.$route.params.data_edit;
        me.filtros.programacion_id = me.form.id;
        me.metodo = "put";

        //Busca detalles de programación
        if (me.$store.getters.can("plantaEx.progrmacion.showDetalles")) {
          await axios
            .get("/api/plant/programacionDetalles?page=" + page, {
              params: me.filtros,
            })
            .then(async (response) => {
              me.det_programaciones = response.data;
            });
        }
        if (me.form.estado == 2) {
          me.bloquear = true;
        }
        me.cargando = false;
      }
    },

    async getEmpresas() {
      await axios
        .get("/api/admin/empresas/lista", {
          params: {
            linea_negocio_id: [17],
          },
        })
        .then(async (response) => {
          this.listasForms.empresas = await response.data;
        });
    },

    async getTipoVehiculo() {
      await axios
        .get("/api/admin/tiposVehiculos/lista", {
          params: {
            linea_negocio_id: [17],
          },
        })
        .then(async (response) => {
          this.listasForms.tipoVehiculo = await response.data;
        });
    },

    getEstados() {
      axios.get("/api/lista/28").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    getAreas() {
      axios.get("/api/lista/78").then((response) => {
        this.listasForms.areas = response.data;
      });
    },

    getDetEstados() {
      axios.get("/api/lista/236").then((response) => {
        this.listasForms.det_estados = response.data;
      });
    },

    save() {
      this.cargando = true;
      axios({
        method: this.metodo,
        url: "api/plant/programaciones",
        params: this.form,
      })
        .then((response) => {
          this.accion = "Editar";
          this.metodo = "put";
          this.form.id = response.data.id;
          this.bloquear = response.data.estado == 2 ? true : false;
          let title = "Se actualizó la programación con éxito.";
          this.$swal({
            icon: "success",
            title: title,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error, vuelva a intentarlo..." + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },

    back() {
      return this.$router.push({
        name: "/plantaExterna/programacion",
      });
    },

    elegirDirectorio() {
      this.plantilla_cargue = this.$refs.file.files[0];
    },

    limpiarPlantilla() {
      const fileInput = document.getElementById("file");
      if (fileInput) {
        fileInput.value = null;
      }
      this.plantilla_cargue = null;
    },

    descargarPlantilla() {
      this.cargando = true;
      axios({
        method: "GET",
        url: "/api/plant/programacion/plantilla",
      })
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          location.href = data.url;
          this.$swal({
            icon: "success",
            title: data.message,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },

    //Carga y/o valida los datos de la plantilla (Excel de Cargue Programaciones)
    async importarCargue() {
      this.cargando = true;
      let formData = new FormData();
      formData.append("programacion_id", this.form.id);
      formData.append("file", this.plantilla_cargue);
      await axios
        .post("/api/plant/programacion/importCargue", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(async (response) => {
          let result_content =
            response.data.error.length > 0
              ? `<div>
                  <p class="text-danger">
                    <strong>No se cargaron todos los datos de la plantilla.</strong>
                  </p>
                </div>`
              : `<div>
                  <p class="text-success">
                    <strong>La plantilla se cargo exitosamente.</strong>
                  </p>
                </div>`;
          if (response.data.error.length > 0) {
            result_content += `<h4>Errores encontrados.</h4>`;
            response.data.error.forEach(
              (err) => (result_content += `<div><small>${err}</small></div>`),
            );
          }
          this.cargando = false;
          await this.$swal({
            title: "Resultado de la carga.",
            html: result_content,
            icon: response.data.error.length > 0 ? "error" : "success",
            showCancelButton: false,
            confirmButtonText: "Ok",
            backdrop: `rgba(0,0,123,0.4) left top no-repeat`,
            allowOutsideClick: false,
          }).then(async (result) => {
            if (result.value) {
              this.accion = "Editar";
              await this.getIndex();
            }
          });
          this.limpiarPlantilla();
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error, vuelva a intentarlo..." + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },

    validarEstado(save = false) {
      if (
        this.form.estado == 2 &&
        (!this.det_programaciones.data || !this.det_programaciones.data.length)
      ) {
        this.$swal({
          icon: "error",
          title: "No tiene ningún detalle cargado...",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        this.form.estado = 1;
        return;
      }

      if (save) {
        this.save();
      }
    },

    enviarCorreo() {
      this.cargando = true;
      axios
        .get("/api/plant/programaciones/enviarCorreo", {
          params: {
            plant_programacion_id: this.form.id,
            empresa_id: this.form.empresa_id,
          },
        })
        .then((response) => {
          this.cargando = false;
          if (response.data.error !== undefined) {
            this.$swal({
              icon: "error",
              title: response.data.error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          } else {
            this.$swal({
              icon: "success",
              title: "Correo enviado satisfactoriamente",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          }
        })
        .catch((e) => {
          this.cargando = false;
          this.$swal({
            icon: "error",
            title: "Error, en el envio de correo:" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
      this.cargando = false;
    },
  },

  async mounted() {
    await this.getEstados();
    await this.getDetEstados();
    await this.getEmpresas();
    await this.getTipoVehiculo();
    await this.getSitios();
    await this.getBloques();
    await this.getCecosYAfes();
    await this.getAreas();
    await this.getTipoProducto();
    await this.getIndex();
  },
};
</script>

<style lang="scss">
[v-cloak] {
  display: none;
}
.edit {
  display: none;
}
.editing .edit {
  display: block;
}
.editing .view {
  display: none;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

.well {
  border: 3px solid #b11f2b;
  border-radius: 5px;
  height: 100%;
  min-height: 20px;
  padding: 14px;
  margin: auto;
  margin-bottom: 10px;
  width: 100%;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
}

.well-legend {
  background: #b11f2b;
  color: #fff;
  border: 2px solid #b11f2b;
  border-radius: 4px;

  display: block;
  font-size: 20px;
  width: auto;
  min-width: 300px;
  padding: 2px 7px 2px 5px;
  line-height: unset;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
}
.table-scroll-x {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
}

.tabla-ancha {
  width: max-content;
  min-width: 100%;
  table-layout: auto;
}

.tabla-ancha th,
.tabla-ancha td {
  white-space: nowrap;
}
</style>
